<script setup>
// NOTICE: KAPTION-INTEGRATION
// whatsapp-message-merging — wraps the one pending bubble that holds an
// agent's merged WhatsApp texts. Deshacer lives on the strip above the
// composer (KaptionPendingSendStrip), so this wrapper only shows the state.
import { useI18n } from 'vue-i18n';

defineProps({
  count: { type: Number, default: 1 },
  paused: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <div class="relative" data-testid="kaption-merge-pending-bubble">
    <div class="relative opacity-70">
      <slot />
    </div>
    <div class="flex justify-end ltr:mr-8 rtl:ml-8 -mt-1">
      <span
        class="flex items-center gap-1.5 rounded-lg px-2.5 py-1 text-xs font-medium"
        :class="
          paused ? 'bg-n-blue-3 text-n-blue-11' : 'bg-n-amber-3 text-n-amber-11'
        "
      >
        <span
          class="size-3"
          :class="paused ? 'i-lucide-pause' : 'i-lucide-clock'"
        />
        {{
          paused
            ? t('KAPTION_MESSAGE_MERGE.BUBBLE.PAUSED')
            : t('KAPTION_MESSAGE_MERGE.BUBBLE.HOLDING')
        }}
        <template v-if="count > 1">
          · {{ t('KAPTION_MESSAGE_MERGE.BUBBLE.MERGED', { count }) }}
        </template>
      </span>
    </div>
  </div>
</template>
